<template>
  <b-modal id="multisiteModel" centered ref="multisiteModel" size="custom-lg" title="Subsites List" :hide-header-close="true" :lazy="true" modal-class="updatepopup" no-fade>
    <div class="prompt-text p-4 text-center">
      Seems you have added a Network site. Here is the list of subsites which you can add to your admin panel automatically in a click.
    </div>
    <b-row class="sitelist-container">
      <div class="card">
        <div class="card-body">
          <b-form-checkbox size="sm" class="master-checkbox darkbg "  v-model="selected" :value="multiSite" v-for="(multiSite,index) in site.sites" :key="index"><span class="site-name">{{multiSite}}</span></b-form-checkbox>
        </div>
      </div>
    </b-row>
    <div slot="modal-footer" class="w-100">
      <div class="text-right">
        <b-link class="pt-4 helper-links" :href="needHelp()" target="_blank" >Help?</b-link>
        <b-btn class="pl-1" @click="addlater" variant="flat">
          Later
        </b-btn>
        <b-btn @click="addNetworkSite" variant="primary" :disabled="disabled()">
          Add Now
          <spinner size="small" v-if="buttonLoader.saveChanges"></spinner>
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  props: ['site'],
  data() {
    return {
      selected: [],
      buttonLoader: {
        saveChanges: false
      },
    }
  },
  watch:{
    site(value){
      _.each(value.sites,(siteName)=>{
        this.selected.push(siteName);
      })
    }
  },
  created(){
    this.appInfo = this.$store.getters.getAppInfo;
  },
  methods: {
    addNetworkSite() {
      this.buttonLoader.saveChanges = true;
      this.$emit("addNetworkSite", { 'parentSiteID': this.site.parentSiteID, 'siteName': this.selected });
    },
    addlater() {
      this.$refs.multisiteModel.hide();
    },
    disabled(){
      if(this.selected == '' || this.buttonLoader.saveChanges){
        return true;
      }
      return false; 
    },
    needHelp(){
      let appInfo = this.$store.getters.getAppInfo;
      return appInfo.SUPPORT_URL+'solution/articles/195272'+appInfo.GA_HELP_TRACKING;
    }

  }
};

</script>
<style scoped>
    .helper-links{
      color: #2386db;
      font-family: Lato;
      font-size: 12px;
      font-weight: 500;
      line-height: 3.58;
      text-align: left;
    }
</style>
